import React from 'react'
import PropTypes from 'prop-types'

const Input = ({
  label,
  field,
  form: { touched, errors },
  ...props
}) => (
  <div className="field">
    <label>
      {label}
      {touched[field.name] && errors[field.name] &&
        <span className="error-message">{errors[field.name]}</span>}
    </label>

    <input {...field} {...props} />
  </div>
)

Input.propTypes = {
  type: PropTypes.string,
}

Input.defaultProps = {
  type: 'text',
}

export default Input
